import yup from '../../../config/yup';

export const peoplesoftWriterValidationSchema = yup.object().shape({
  '@id': yup.string(),
  name: yup
    .string()
    .matches(/^[a-zA-Z_$][a-zA-Z0-9_$]*$/, {
      message:
        'Name must start with a letter or underscore and can only contain letters, numbers, and underscores',
    })
    .required('Name is required'),
  type: yup.string().default('peoplesoftWriter'),
  delayedRead: yup.boolean(),
  onError: yup.string(),
  format: yup.string(),
  connectionKey: yup.string(),
  properties: yup.object().shape({
    paginationType: yup.string().oneOf(['QueryString', 'RequestBody', 'Stream']),
    token: yup.string(),
    url: yup.string(),
    httpMethod: yup
      .string()
      .oneOf(['GET', 'POST', 'PUT', 'DELETE'])
      .required('HTTP Method is required'),
    headers: yup.string(),
    headersJson: yup.string(),
  }),
});
